import { useState, useEffect } from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form, Spin } from 'antd';
import axios from 'axios';
import Tab1 from './Tab1';
import Utilisateur from '../../../../../Models/Utilisateur';
import { useAuthHeader, useAuthUser } from '../../../../../Services/Auth/sessionAuth';
import Data from '../../../../../Data/Data.json'
import SweetAlert from "sweetalert2"
import { Crypter } from '../../../../../Functions/Security/Crypter';
import { Backdrop, CircularProgress, Typography } from '@mui/material';
import formatNumber from '../../../../../Functions/Traitement/FormatNumber';
import Cheque from '../../../../../Models/Cheque';
import VerifDay from '../../../../../Functions/Traitement/VerifDay';
import { useNavigate } from 'react-router-dom';

//import '../../../../Assets/Styles/StyleForm.css';
const Swal = require('sweetalert2');

const BackToBank = () => {
    // USER SESSION
    const auth = useAuthUser()
    const user: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // USER TOKEN
    const authHeader = useAuthHeader()

    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [StartSearchG, SeStartSearchG] = useState(false);
    const [StartForm, SetStartForm] = useState(true);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [modifActve, setModifActve] = useState(true)
    const [enregActve, setEnregActve] = useState(true)
    const [consulActive, setConsulActive] = useState(false)
    const [sbmit, setSbmit] = useState("");
    const [DataCheque, setDataCheque] = useState<Cheque[]>([]);
    // const [DataOperationV, setDataOperationV] = useState<DataHistoCpt[]>([]);
    const [StartRef, SetStartRef] = useState(false);
    const Navigate=useNavigate();

    useEffect(() => {
        forceUpdate({});
        if (StartForm == true) {
            GetAllSaisieAgence();
            VerifDay(user.coduti,user.codage,authHeader,Navigate);
            let DateD = user.datjour;
            form.setFieldValue("DATOPE", DateD);
            SetStartForm(false);
        }
    }, []);


    function initialiazeButton() {
        setAjoutActif(false)
        setModifActve(true)
        setEnregActve(true)
        setConsulActive(false)
    }

    function cunsultButton() {
        //setAnnulActive(false)
        setSbmit("add");
        setAjoutActif(true);
        setEnregActve(false);
        SetStartForm(false);
        SetStart();
        // SetActivetabs(true)
    }


    const SetStart = async (Value?: string) =>
     {
        setLoad(true);

        let ETatCheque = form.getFieldValue('EtatCheque');
        if (typeof Value !== 'undefined') { ETatCheque = Value; }
        form.setFieldsValue({ "CODOPE": '', "lib_CODOPE": '', "CODOPEC": '', 'lib_CODOPEC': '' })

        let config1 = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetGetCodeOperat,
            headers: {
                'CypherChampOpe': Crypter.encrypt('OPE018'),
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
        }

        let data: string = Crypter.encrypt('OPE009');

        if (ETatCheque === true) { data = Crypter.encrypt('OPE003'); }
        else
        if (ETatCheque === false) { data = Crypter.encrypt('OPE038'); }

        let config2 = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetGetCodeOperat,
            headers: {
                'CypherChampOpe': data,
                'Authorization': authHeader(),
                'Content-Type': 'application/json'
            },
        };

        let requestOne = axios.request(config1);
        let requestTwo = axios.request(config2);

        await axios
            .all([requestOne, requestTwo])
            .then(
                await axios.spread(async (...responses: any) => {

                    const responseOne = responses[0];
                    const responseTwo = responses[1];

                    if (responseOne.data) {
                        const res1 = JSON.parse(Crypter.decrypt(responseOne.data)).Value;

                        if (res1.StatutCode == 200) {
                            let data1 = res1.Result[0];
                            form.setFieldsValue({ "CODOPE": data1.OPE018, "lib_CODOPE": data1.LIBELL });

                            if (responseTwo.data) {
                                const res2 = JSON.parse(Crypter.decrypt(responseTwo.data)).Value;
                                if (res2.StatutCode == 200) {
                                    let data2 = res2.Result[0];

                                    if (ETatCheque === true) { form.setFieldsValue({ "CODOPEC": data2.OPE003, "lib_CODOPEC": data2.LIBELL }); }
                                    else
                                        if (ETatCheque === false) { form.setFieldsValue({ "CODOPEC": data2.OPE038, "lib_CODOPEC": data2.LIBELL }); }
                                }
                                else {
                                    setLoad(false);
                                    SweetAlert.fire({ title: "error", text: res2.Message, icon: "error" })
                                }

                                setConsulActive(true);
                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res1.Message, icon: "warning" })
                            }
                        }
                    }
                }
                )).catch((errors) => {
                    SweetAlert.fire({ title: "error", text: errors.message, icon: "error" })
                });

        setLoad(false);
    }

    const GetAllSaisieAgence = async () => {

        setLoad(true);
        setDataCheque([]);
        
        initialiazeButton()

        form.resetFields();

        var config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.GetChequeAccount,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': authHeader(),
                'CypherNumcli': Crypter.encrypt(""),
                'CypherAgence': Crypter.encrypt(user.codage),
                'CypherOption': Crypter.encrypt('3'),
            }
        }

        await
            axios(config)
                .then((response) => {
                    if (response.data) {
                        const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                        if (res.StatutCode == 200) {
                            let datas = res.Result;

                            const Datat: Cheque[] = [];
                            if (datas.length === 0) {
                                SweetAlert.fire({ title: "Warning", text: "aucun élément", icon: "warning" })
                            }
                            else {
                                res.Result.map((data: any, indice: number) => {
                                    Datat.push({
                                        key: indice,
                                        Id: data.Id,
                                        CODOPE: data.CODOPE,
                                        NUMCPT: data.NUMCPT,
                                        Client: data.NUMCLI + '--' + data.lib_NUMCLI,
                                        NUMCHQ: data.NUMCHQ,
                                        CPTCHQRECOUVRE: data.CPTCHQRECOUVRE,
                                        BANCLT: data.BANCLT,
                                        DATOPE: data.DATOPE,
                                        MONTAN: formatNumber(data.MONTAN),
                                        LIBECR: data.LIBECR,
                                        REMETT: data.REMETT,
                                        CPTBAN: data.CPTBAN,
                                        NUMBAN: data.NUMBAN,
                                        CPTCLT: data.CPTCLT,
                                        DATSAI: data.DATSAI,
                                        BORDER: data.BORDER,
                                        DATVAL: data.DATVAL,
                                        CPTJNX: data.CPTJNX,
                                        CDETAT: data.CDETAT,
                                        CPTCHC: data.CPTCHC,
                                        AGCCPT: data.AGCCPT,
                                        NBRIMPAIE: data.NBRIMPAIE,
                                        CPTRECOUVRE: data.CPTRECOUVRE,
                                        MTESCOMPTE: data.MTESCOMPTE,
                                        CPTENCCOR: data.CPTENCCOR,
                                        VALNONPAIPRE: data.VALNONPAIPRE,
                                        cptescompte: data.cptescompte,
                                        Lib_BANQUE: data.BANCLT + "-" + data.lib_BANCLT,
                                        RelObject: data
                                    });

                                    setDataCheque(Datat);
                                })
                            }
                        } else SweetAlert.fire({ title: res.Message, text: res.Result, icon: "warning" })

                    }
                    //  setLoad(false);
                }).catch((error) => {
                    SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                })
        setLoad(false);
    }

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Retour Chèque Encaissements
                </span>
            ),
            children: <Tab1 etatG={StartRef} form={form} DataCheque={DataCheque} OnModif={cunsultButton} OnchangeEtat={SetStart} />,
        }
    ]

    const onFinish = (values: any) => {
        let Cheque: Cheque = values;
        Cheque.LIBECR = values.lib_CODOPE;
        Cheque.DATOPE = (new Date(user.datjour)).toLocaleDateString("fr").replaceAll("/", '-');
        Cheque.UTISAI = user.coduti;
        Cheque.CODAGE = user.codage;
        Cheque.CODOPEC = values.CODOPEC;
        Cheque.LIBECRC = values.lib_CODOPEC;

        if (sbmit == "add") {
            SweetAlert.fire({
                title: "Retour Chèque à la banque",
                text: "Voulez-vous effectuer le retour du Chèque chez " + form.getFieldValue('lib_NUMCPT') + " ? ",
                showCancelButton: true,
                color: "#116599",
                confirmButtonText: "Yes",
                confirmButtonColor: "#116599",
                cancelButtonColor: "darkred",
                cancelButtonText: "No",
                showLoaderOnConfirm: true,
                icon: 'question'
            }).then(async (res) => {
                if (res.isConfirmed) {
                    setLoading(true);
                    setIsSubmit(true)
                    //let group = profilsDistant.find(()=>)
                    let data = Crypter.encrypt(JSON.stringify(Cheque));

                    let config = {
                        method: 'post',
                        maxBodyLength: Infinity,
                        url: Data.ApiUrl.RetourBank,
                        headers: {
                            'Authorization': authHeader(),
                            'Accept': '*/*',
                            'Content-Type': 'application/json',
                            'CypherEtat': Crypter.encrypt(values.EtatCheque.toString())
                        },
                        data: data
                    };

                    await axios.request(config)
                        .then((response) => {
                            setLoading(false);
                            if (response.data) {
                                const res = JSON.parse(Crypter.decrypt(response.data)).Value;
                                if (res.StatutCode == 200) {
                                    let result = res.Result;
                                    form.resetFields();

                                    GetAllSaisieAgence();
                                    setIsSubmit(false);
                                    SweetAlert.fire({ title: res.Message, text: result, icon: "success" });
                                    setSbmit("");
                                }
                                else {
                                    SweetAlert.fire({ title: res.Message, text: res.Result, icon: "error" })
                                }
                                setLoading(false);
                            }
                        })
                        .catch((error) => {
                            setLoading(false);
                            console.log(error)
                            SweetAlert.fire({ title: "Error", text: error.message, icon: "error" })
                        });
                }
            })
        }


    };


    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> Retour Chèque Encaissements Cas Complet :</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: '#116599' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"#116599"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                {/* <Button size='large' className='bt_add' disabled={consulActive} onClick={consult} type="ghost" htmlType="button" block  >
                                    Consulter
                                </Button> */}
                                {/* <Button size='large' className='bt_add' disabled={ajoutActve} onClick={SetStart} type="ghost" htmlType="button" block  >
                                    Ajouter
                                </Button> */}

                                <Button size='large' className='bt_add' onClick={e => GetAllSaisieAgence()} disabled={false} type="ghost" htmlType="button" block  >
                                    Actualiser
                                </Button>
                               
                                <Button size='large' className='bt_add' disabled={enregActve} type="ghost" htmlType="submit" block>
                                    Enregistrer
                                </Button>

                            </Space>
                        </Form.Item>
                        <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={load} >
                            <CircularProgress color="inherit" />
                        </Backdrop>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" onChange={(e) => { if (e == '2') { } }} defaultActiveKey="1" items={items} />
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}
export default BackToBank;